<div fxLayout="row" fxLayoutAlign="space-between start" [ngClass]="{ odd: odd, even: even }">
  <div fxFlex="25" class="col" (click)="showDescription = !showDescription">{{ treatment.PriceListCode.Code }}</div>
  <div fxFlex="35" class="col" (click)="showDescription = !showDescription">{{ treatment.Name }}</div>  
  
  <div fxFlex="20" class="col" (click)="showDescription = !showDescription" *ngIf="!canChangePrice">{{ treatment.Price }}</div>
  <div fxFlex="20" class="col"  *ngIf="canChangePrice">
    <mat-form-field>
      <input type="number" matInput inputmode="numeric" min="0"  [(value)]="treatment.Price" (change)="onChangePrice($event)"/>
    </mat-form-field>
  </div>
 
  <div fxFlex="20" class="col">
    <button *ngIf="isSeries()" mat-raised-button color="primary" (click)="onSelect($event)">{{ 'TREATMENT.SELECT'| translate }}</button>
    <mat-checkbox *ngIf="!isSeries()" color="primary" (change)="onChange($event)" [checked]="treatment.Selected"></mat-checkbox>
  </div>
</div>

<div fxLayout="row"  [ngClass]="{ odd: odd, even: even }" *ngIf="treatment.TotalPaid > 0 && !treatment.Paid">
  <div fxFlex="80" fxLayoutAlign="end center" class="col" style="line-height: 2em;" (click)="showDescription = !showDescription">
    <span style="color:orange;">      
      {{ 'COMMON.PARTIALLY-PAID' | translate}}: 
    </span>
    <span>{{ treatment.TotalPaid }}</span>    
  </div>
  <div fxFlex="20"></div>
</div>

<div *ngIf="showDescription" fxLayout="row" fxLayoutAlign="space-between" [ngClass]="{ odd: odd, even: even }"
  class="row">
  <div fxFlex="25" fxLayoutAlign="start" class="col primary description">{{ 'TREATMENT.DESCRIPTION' | translate }}
  </div>
  <div fxFlex="75" fxLayoutAlign="start" class="col description">{{ treatment.Description }}</div>
</div>